(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("@wallaby-ui/haidi", [], factory);
	else if(typeof exports === 'object')
		exports["@wallaby-ui/haidi"] = factory();
	else
		root["@wallaby-ui/haidi"] = factory();
})(self, function() {
return 